export enum BuyerType {
  consumer = 'consumer',
  entrepreneur = 'entrepreneur',
}
